import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const description: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
  mb: 2,
};
